import { requestFormPost } from '@/common/request';

export type batchQueryActivityExtInfoParams = {
  squareActivityExtQueryStr: string;
};

export interface batchQueryActivityExtInfoRes {
  ret: string;
  msg: string;
  data: Array<{
    activityType: number;
    activityId: number;
    planCode: string;
    hdActivityName: string;
    hdActivityLevel: string;
    hdActivityStartTime: number;
    hdActivityEndTime: number;
    businessStartTime: number;
    businessEndTime: number;
    signAgreement: boolean;
    channelId: string;
    channelName: string;
    channelPic: string;
    channelRemark: string;
    demoImgUrl: string;
    benefitTagList: Array<string> | [];
    umActivityId: number;
    roomId: string;
    resourceId: string;
  }>;
}

//
export async function batchQueryActivityExtInfo(
  params: batchQueryActivityExtInfoParams
): Promise<batchQueryActivityExtInfoRes> {
  return await requestFormPost('/generic/mac/square/batchQueryActivityExtInfo', params);
}
